import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Videos } from '../../components'
import { selectCurrentPhoneId } from '../App/selectors'
import { browserHistory } from 'react-router'
import {
  selectVideos,
  selectVideosFetching,
  selectCurrentPhoneVideoId
} from './selectors'
import { createEvent } from '../UserEvents/actions'
import { DeviceNotLoadedHOC } from '../../hocs'

const VideosContainer = ({
  videos,
  params,
  preSaleFlag,
  query,
  currentPhoneId,
  createUserEvent,
  router,
  isFetching
}) => {
  const [currentVideoId, setCurrentVideoId] = useState()

  useEffect(() => {
    if (!params || !videos.length) {
      return
    }
  
    const videoBySlug = videos.find(video => video.slug === params?.videoId)
    
    if (videoBySlug) {
      setCurrentVideoId(videoBySlug.pk)
      return
    } 
    
    const videoById = videos.find(video => (
      parseInt(video.pk, 10) === parseInt(params?.videoId, 10)
    ))
    
    if (videoById) {
      router.replace({
        pathname: `/videos/${videoById.slug}`,
        query
      })
      return
    }

    if (!params?.videoId) {
      setCurrentVideoId(videos[0].pk)
      return
    }

    if (params?.videoId) {
      browserHistory.replace('/404')
    }
    
  }, [params, videos.length])

  const getRelatedVideos = (videos, videoId) => {
    if (videos.length !== 0 && videoId === undefined) {
      videoId = videos[0].pk
    }

    return videos.filter(vid => parseInt(videoId, 10) !== vid.pk)
  }
  
  const relatedVideos = getRelatedVideos(videos, currentVideoId)

  return (
    <Videos
      videos={videos}
      videoId={currentVideoId}
      relatedVideos={relatedVideos}
      noSideBar={preSaleFlag}
      noSearchBar={preSaleFlag}
      query={query}
      currentPhoneId={currentPhoneId}
      isFetching={isFetching}
      createUserEvent={createUserEvent}
    />
  )
}

const mapStateToProps = state => ({
  currentPhoneId: selectCurrentPhoneId(state),
  videos: selectVideos(state),
  isFetching: selectVideosFetching(state),
  currentPhoneVideoId: selectCurrentPhoneVideoId(state),
  query: state.routing.locationBeforeTransitions.query,
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceNotLoadedHOC(VideosContainer))



// WEBPACK FOOTER //
// ./src/containers/Videos/Videos.js